import { Asset } from './asset'
import { request, requestJSON } from './request'

export interface Release {
  pk: number
  name: string
  description: string
  release_notes?: string
  assets: Asset[]
}

export async function getProjectRelease (releaseId: number): Promise<Release> {
  return await requestJSON(`/api/project-releases/${releaseId}/`)
}

interface CreateRelease {
  project_id: string
  name: string
  description: string | null
  release_notes: string | null
  assets: number[]
}

interface CreateReleaseResp {
  release_pk: number
}

export async function createProjectRelease (body: CreateRelease): Promise<CreateReleaseResp> {
  return await requestJSON('/api/project-releases/', { method: 'POST', body })
}

export interface EditRelease {
  name: string
  description: string | null
  release_notes: string | null
}

export async function editProjectRelease (releaseId: number, body: EditRelease): Promise<void> {
  // NB: Not using requestJSON because this request's response body is empty
  await request(`/api/project-releases/${releaseId}/`, {
    method: 'PUT',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' }
  })
}

export async function deleteProjectRelease (releaseId: number): Promise<void> {
  await request(`/api/project-releases/${releaseId}/`, { method: 'DELETE' })
}
